import React from "react";
import { Button, Divider, Icon, Input, Popconfirm, Table } from "antd";
import { SortOrder, TableProps } from "antd/lib/table";
import { tableFooter, tableSort } from "../../../components/util";
import { ButtonsGroup } from "./buttonsGroup";

/** for search results in table */
const handleSearch = (_: React.Key[], confirm: () => void) => {
    confirm();
};

const handleReset = (clearFilters: () => void) => {
    clearFilters();
};

function getColumnSearchProps<T>(dataIndex: keyof T) {
    let searchInput: Input | null = null;

    return {
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }: {
            setSelectedKeys: (selectedKeys: string[]) => void;
            selectedKeys: React.Key[];
            confirm: () => void;
            clearFilters: () => void;
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`Pesquisar...`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Pesquisar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    limpar
                </Button>
            </div>
        ),
        filterIcon: (filtered: boolean) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
        onFilterDropdownVisibleChange: (visibleDropdown: boolean) => {
            if (visibleDropdown) {
                setTimeout(() => searchInput?.focus(), 100);
            }
        },
        onFilter: (value: string, record: T) =>
            record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()) ?? false,
        sortDirections: ["descend", "ascend"] as SortOrder[],
        sorter: (a: T, b: T) => tableSort(a[dataIndex], b[dataIndex]),
    };
}

interface ActionInTableProps {
    handleEdit: () => void;
    deleteRow: () => void;
}

function ActionInTable({ handleEdit, deleteRow }: ActionInTableProps) {
    return (
        <>
            <Button
                type="link"
                style={{
                    padding: 0,
                }}
                onClick={handleEdit}
                size="small"
            >
                Editar
            </Button>
            <Divider type="vertical" />
            <Popconfirm title="Tens certeza que desejas eliminar?" okText="Ok" cancelText="Não" onConfirm={deleteRow}>
                <Button
                    type="link"
                    style={{
                        padding: 0,
                        color: "#fa541c",
                    }}
                    size="small"
                >
                    Eliminar
                </Button>
            </Popconfirm>
        </>
    );
}

interface IListProps<T> extends TableProps<T> {
    handleNew: () => void;
    exportList: (type: "pdf" | "xls") => void;
    toogleShowDeletedRecords: (value: boolean) => void;
}

function List<T>({ exportList, handleNew, toogleShowDeletedRecords, dataSource, ...rest }: IListProps<T>) {
    const recordsTotal = dataSource?.length;
    return (
        <>
            <ButtonsGroup
                exportList={exportList}
                toogleShowDeletedRecords={toogleShowDeletedRecords}
                handleNew={handleNew}
            />
            <Table
                size="middle"
                pagination={{
                    defaultPageSize: 10,
                }}
                footer={() => tableFooter(recordsTotal)}
                dataSource={dataSource}
                {...rest}
            />
            ;
        </>
    );
}

export const QmDimensionTable = {
    columnsSearch: getColumnSearchProps,
    list: List,
    actions: ActionInTable,
};
